import React from 'react';

import { ContainerInner } from '../common/ContainerInner';

type Props = {
    readonly productId?: string;
};

export default class ProductNotFound extends React.Component<Props> {
    render() {
        return (
            <ContainerInner>
                <div className="no-elements">
                    <h4>
                        Product with id <em>{this.props.productId}</em> could not be found.
                    </h4>
                    <a onClick={() => window.history.back()} className="bt bt-green large back">
                        <i className="material-icons big">keyboard_backspace</i> Go back
                    </a>
                </div>
            </ContainerInner>
        );
    }
}
